module.exports = __webpack_public_path__ + "static/odroidt-3b3dd797dcd645f62a93b69ba3a97dc9.png";